const THEMES = [
  { 'MP': 'Морские пути' },
  { 'VVP': 'внутренние водные пути' },
  { 'MS': 'моторное судно' },
  { 'GS': 'гидроцикл' }
];

export default THEMES;